import React, { useCallback, useContext, useState } from "react";
import {
  Navbar,
  Nav,
  Container,
  Button,
  // Figure,
  Image,
  // DropdownButton,
  Dropdown,
  NavDropdown,
  Col,
  Row,
  Modal,
} from "react-bootstrap";
import {
  // ArrowBarRight,
  DoorOpen,
  Headset,
  // HeadsetVr,
  // Buildings,
  // Bullseye,
  // Cart,
  // List,
  // People,
  PersonCircle,
  // Router,
  // Wallet2,
  CardChecklist,
  Wifi,
  HouseDoor,
  // Boxes
} from "react-bootstrap-icons";
import { Route, Routes, Link, useNavigate } from "react-router-dom";
import WelcomeScreen from "./WelcomeScreen";
import UserProfile from "../User/UserProfile";
import TransactionHistory from "../User/TransactionHistory";
import { Store } from "../../Store";
import UserFinance from "../User/UserFinance";
// import ProductMgtScreen from "../Admin/AdminProducts";
// import AdminFinance from "../Admin/AdminFinance";
// import AdminNotice from "../Admin/AdminNotice";
// import AdminOrders from "../Admin/AdminOrders";
// import AdminStats from "../Admin/AdminStats";
import StoreScreen from "./StoreScreen";
// import UserData from "../Admin/UserData";
// import { PaystackButton } from "react-paystack";
import axios from "axios";
import ToastIt from "../../components/Toast";
// import { getError } from "../../Utils/GetErrors";

function HomeScreen() {
  const navigate = useNavigate()
  const {state, dispatch: ctxDispatch } = useContext(Store);
  const { products, userInfo, baseUrl, noticeContent } = state;

  // Signout handler function
  const signoutHandler = useCallback(() => {
    ctxDispatch({ type: "USER_SIGNOUT" });
  }, [ctxDispatch]);

  // const [isSidebarOpen, setIsSidebarOpen] = useState(true);
  const [showDropdown, setShowDropdown] = useState(false);
  const [showContact, setShowContact] = useState(false);

  const handlePersonClick = () => {
    setShowDropdown(!showDropdown);
  };

  const amount = 50;
  const [showToast, setShowToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [variance, setVariance] = useState("");
  const [rechargeID, setRechargeID] = useState([]);
  const [showAlert, setShowAlert] = useState(false);
  const handleClose = () => setShowAlert(false);

  const refreshToken = async () => {
    try {
      const { data } = await axios.post(`${baseUrl}/auth/refresh-token`, {
        token: userInfo.refreshToken,
      });
      ctxDispatch({ type: "USER_LOGIN", payload: data });
      localStorage.setItem("userInfo", JSON.stringify(data));
      return data.token;
    } catch (error) {
      console.error("Error refreshing token:", error);
      signoutHandler();
      return null;
    }
  };
  
  const processRequest = async (e) => {
    e.preventDefault();
    //get next recharge ID
    setShowAlert(true);
    try {
      const { data } = await axios.get(`${baseUrl}/recharge/next-recharge-id`)
      setRechargeID(data.nextRechargeId);
      // console.log('rID',rechargeID)
    } catch (error) {
      if (error.response && error.response.status === 401) {
        const newToken = await refreshToken();
        if (newToken) {
          processRequest(e); // Retry the request with the new token
        }
      } else {
        setVariance("danger");
        setToastMessage(
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message
        );
      setShowToast(true);
    }
  }
  }

  const handleRequest = async (e) => {
    e.preventDefault();
    setShowAlert(false);
    try {
      const { data } = await axios.post(
        `${baseUrl}/recharge`,
        { amount },
        {
          headers: { Authorization: `Bearer ${userInfo.token}` },
        }
      );
      // setMyRequests([data, ...MyRequests]);
      // setRechargeID(data.rechargeId);
      console.log(data);
      setVariance("success");
      setToastMessage(
        `Recharge request submitted successfully. Your reference ID is ${rechargeID}`
      );
      setShowToast(true);
      
      // SEND SMS
      function sendPaymentNotification2Admin() {
              if (data) {
                try {
                  const apiUrl = `https://apps.mnotify.net/smsapi?key=zwNY4rjo1XWnMXn8Om7Q8gk1U&to=233548785316&msg=AGENT REQUEST made successfully by ${userInfo.username}&sender_id=KYE-TECH`;
                  fetch(apiUrl)
                  // .then((response) => response.json(response.data));
                  .then((response) => console.log('smsFeedback',response));
                } catch (error) {
                  console.error("Error sending SMS:", error);
                }
              }
            }
            sendPaymentNotification2Admin();
            // setAmount(""); // Reset the input field
    } catch (error) {
      if (error.response && error.response.status === 401) {
        const newToken = await refreshToken();
        if (newToken) {
          handleRequest(e); // Retry the request with the new token
        }
      } else {
        setVariance("danger");
        setToastMessage(
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message
        );
        setShowToast(true);
      }
    }
  };

  // const handlePaystackSuccessAction = async () => {
  //   setToastMessage("Payment made successfully, please wait...");
  //   setVariance("success");
  //   setShowToast(true);
  //   let userId = userInfo._id;
  //   let userLevel = "Agent";
  //   try {
  //     const { data } = await axios.put(
  //       `${baseUrl}/user/${userId}/level`,
  //       { userLevel },
  //       {
  //         headers: { Authorization: `Bearer ${userInfo.token}` },
  //       }
  //     );
  //     ctxDispatch({ type: "UPDATE_USERDATA", payload: data });
  //     // localStorage.setItem("userInfo", JSON.stringify(data));
  //     // setUsers(Users.map(user => (user._id === userId ? data.user : user)));
  //     setToastMessage(`User ${userInfo.username} updated is now an Agent`);
  //     setVariance("success");
  //     setShowToast(true);
  //     signoutHandler();
  //   } catch (error) {
  //     setToastMessage(getError(error));
  //     setVariance("danger");
  //     setShowToast(true);
  //   }
  // };

  // const handlePaystackCloseAction = () => {
  //   setToastMessage("Payment cancelled");
  //   setVariance("danger");
  //   setShowToast(true);
  // };

  // const paystackConfig = {
  //   reference: new Date().getTime().toString(),
  //   email: userInfo?.email,
  //   currency: "GHS",
  //   amount: 3700,
  //   publicKey: process.env.REACT_APP_PAYSTACK_URL,
  // };


  // const componentProps = {
  //   ...paystackConfig,
  //   text: "AGENT REGISTRATION",
  //   onSuccess: (reference) => handlePaystackSuccessAction(reference),
  //   onClose: handlePaystackCloseAction,
  // };

  return (
    <>
      <div className="d-flex">
        {/* Sidebar */}
          {/* <div
            className={`bg-dark text-white ${
              isSidebarOpen ? "w-auto" : "w-10"
            } transition-all ${!isSidebarOpen ? "d-none d-md-block" : ""}`}
            style={{ minHeight: "100vh" }}
          >
            {* <span
            variant="light"
            style={{cursor:'pointer', color:'white', fontSize:'2rem'}}
            className="m-2 float-end"
            onClick={() => setIsSidebarOpen(!isSidebarOpen)}
          >
            {isSidebarOpen ? <List/> : <ArrowBarRight/>}
          </span> *}
          <Nav className="flex-column">
            {isSidebarOpen && (
              <Figure className="mx-auto">
                <Figure.Image
                  roundedCircle
                  width={91}
                  height={100}
                  alt="user-image"
                  src="/images/logo.jpg"
                ></Figure.Image>
                <Figure.Caption className="text-light text-center">
                  {userInfo?.username}
                </Figure.Caption>
                <Figure.Caption className="text-light text-center" style={{textTransform:'uppercase'}}>
                  {userInfo?.userLevel}
                </Figure.Caption>
              </Figure>
            )}
            <Nav.Link
              as={Link}
              className="text-white d-flex align-items-center border-top"
              to="/home"
            >
              <Buildings style={{ fontSize: "1em" }} />
              &nbsp;
              {isSidebarOpen && " Home"}
            </Nav.Link>
            {/* <Nav.Link as={Link} className="text-white d-flex align-items-center mt-2" to="/home/details" >
              <PersonCircle  style={{ fontSize: '1em' }} />&nbsp;
              {isSidebarOpen && ' General Transactions'}
              </Nav.Link> *}
            <Nav.Link
              as={Link}
              className="text-white d-flex align-items-center"
              to="/home/user-details"
            >
              <PersonCircle style={{ fontSize: "1em" }} />
              &nbsp;
              {isSidebarOpen && " Profile"}
            </Nav.Link>
            <Nav.Link
              as={Link}
              className="text-white d-flex align-items-center"
              to="/home/my-transactions"
            >
              <CardChecklist style={{ fontSize: "1em" }} />
              &nbsp;
              {isSidebarOpen && "Transaction"}
            </Nav.Link>


            <Nav.Link
              as={Link}
              className="text-white d-flex align-items-center"
              to="https://wa.ma/233595548478"
            >
              
              <Headset style={{ fontSize: "1em" }} />
              &nbsp;
              {isSidebarOpen && " Support"}

            </Nav.Link>

            {userInfo && userInfo.userLevel === "Admin" && (
<>
            {isSidebarOpen && (
              <Navbar.Brand className="border-bottom text-center">SERVICES</Navbar.Brand>
            )}

            <Nav.Link
              as={Link}
              className="text-white d-flex align-items-center"
              to="/home/admin/products"
            >
              <Boxes style={{ fontSize: "1em" }} />
              &nbsp;
              {isSidebarOpen && " Products"}
            </Nav.Link>
            {/* <Nav.Link
              as={Link}
              className="text-white d-flex align-items-center"
              to="/home/airtelTigo"
            >
              <Bullseye style={{ fontSize: "1em" }} />
              &nbsp;
              {isSidebarOpen && " AirtelTigo"}
            </Nav.Link>
            <Nav.Link
              as={Link}
              className="text-white d-flex align-items-center"
              to="/home/telecel"
            >
              <Bullseye style={{ fontSize: "1em" }} />
              &nbsp;
              {isSidebarOpen && " Telecel"}
            </Nav.Link> *}

            {isSidebarOpen && (
              <Navbar.Brand className="border-bottom text-center">STATISTICS</Navbar.Brand>
            )}
            <Nav.Link
              as={Link}
              className="text-white d-flex align-items-center"
              to="/home/admin/statistics"
            >
              <Bullseye style={{ fontSize: "1em" }} />
              &nbsp;
              {isSidebarOpen && " Summary"}
            </Nav.Link>

            <Nav.Link
              as={Link}
              className="text-white d-flex align-items-center"
              to="/home/admin/finance"
            >
              <Wallet2 style={{ fontSize: "1em" }} />
              &nbsp;
              {isSidebarOpen && " Top ups"}
            </Nav.Link>
            <Nav.Link
              as={Link}
              className="text-white d-flex align-items-center"
              to="/home/admin/orders"
            >
              <Cart style={{ fontSize: "1em" }} />
              &nbsp;
              {isSidebarOpen && " Orders"}
            </Nav.Link>
            <Nav.Link
              as={Link}
              className="text-white d-flex align-items-center"
              to="/home/admin/users"
            >
              <People style={{ fontSize: "1em" }} />
              &nbsp;
              {isSidebarOpen && " Users"}
            </Nav.Link>

            {isSidebarOpen && (
              <Navbar.Brand className="border-bottom text-center">OTHERS</Navbar.Brand>
            )}

            <Nav.Link
              as={Link}
              className="text-white d-flex align-items-center"
              to="/home/admin/extras"
            >
              <Router style={{ fontSize: "1em" }} />
              &nbsp;
              {isSidebarOpen && "Other Info"}
            </Nav.Link>
            </>
            )}      
          </Nav>
        </div> */}

        {/* NAVBAR */}
        <div className="flex-grow-1">
          <Navbar bg="light" className="border-bottom">
            <Nav className="me-auto">
              {/* <span
                variant="light"
                style={{
                  cursor: "pointer",
                  color: "darkgrey",
                  fontSize: "2rem",
                }}
                className="m-2 float-end"
                onClick={() => setIsSidebarOpen(!isSidebarOpen)}
              >
                {isSidebarOpen ? <List /> : <ArrowBarRight />}
              </span> */}
              <div className="d-flex flex-wrap">
                <Button as={Link} variant="info" className="m-2 pb-0 flex-grow-1" to="/home/topup" >
               + Topup
                </Button>
                {/* <Button  variant="dark" className="m-2" to='/home/buy'>
                  <Wifi /> Buy Bundle
                </Button> */}
                <Dropdown>
                  <Dropdown.Toggle className="m-2 p-3 flex-grow-1" variant="dark"><Wifi /> Buy Bundle</Dropdown.Toggle>
                  <Dropdown.Menu>
                    {products
                    .filter((product) => product.status === "available")
                    .map((product) => (
                    <Dropdown.Item as={Link} to={`/home/buy/${product.network}`} key={product.network}>
                      {product.network}
                    </Dropdown.Item>
                    ))}

                  </Dropdown.Menu>
                </Dropdown>

              </div>
            </Nav>
            {userInfo && userInfo.userLevel === "Customer" && (
            <Nav.Link  className="text-white d-flex align-items-center">
              <Button className="btn btn-outline p-1 mx-1" onClick={processRequest}>Become Agent</Button>
            </Nav.Link>
               )} 
            {userInfo && userInfo.userLevel === "Admin" && (
            <Nav.Link  className="text-white d-flex align-items-center" href='/admin'>
              <Button className="btn btn-outline p-1 mx-1" >GoToAdmin</Button>
            </Nav.Link>
               )} 
               {/* // <Nav.Link  className="text-white d-flex align-items-center">
                  <PaystackButton {...componentProps}  className="btn btn-outline p-1 mx-1"/>
                </Nav.Link> */}
            {/* <> AGENT REGISTRATION</>&nbsp; */}
            <Navbar.Brand href="#" className="position-relative">
              <Image src="/images/logo.png" width="30" height="30" className="rounded-circle" onClick={handlePersonClick}/>
                {showDropdown && ( 
            <div className="dropdown-menu show position-absolute" style={{ top: '100%', right: 0 }}>
              {/* <NavDropdown.Item href="/profile">Account</NavDropdown.Item> */}
              {/* <NavDropdown.Divider /> */}
              {/* <NavDropdown.Item href="#action/3.2">Change Password</NavDropdown.Item> */}
              {/* <NavDropdown.Divider /> */}
              <NavDropdown.Item onClick={signoutHandler}><DoorOpen style={{ fontSize: "1em" }} /> Logout</NavDropdown.Item>
              {/* <NavDropdown.Divider />
              <NavDropdown.Item href="#action/3.2">See Profile</NavDropdown.Item> */}
            </div>
          )} 
            </Navbar.Brand>
          </Navbar>

          {/* Main Content */}
                <Container fluid>
                <Routes>
                  <Route path="/" element={<WelcomeScreen />} />
                  <Route path="user-details" element={<UserProfile />} />
                  <Route path="my-transactions" element={<TransactionHistory />} />
                  <Route path="topup" element={<UserFinance />} />
                  <Route path="buy/*" element={<StoreScreen />} />
                  {/* <Route path="admin/products" element={<ProductMgtScreen />} />
                  <Route path="admin/statistics" element={<AdminStats />} />
                  <Route path="admin/finance" element={<AdminFinance />} />
                  <Route path="admin/orders" element={<AdminOrders />} />
                  <Route path="admin/extras" element={<AdminNotice />} />
                  <Route path="admin/users" element={<UserData />} /> */}
                </Routes>
                </Container>
              </div>
              </div>
                <Container fluid className="fixed-bottom bg-light py-2">
                  <Row className="d-flex justify-content-center align-items-center gap-md-5 flex-wrap">
                    <Col
                    as={Button}
                    variant="light"
                    className="px-1 py-3 border"
                    style={{ flex: 1, height: "70px", width: "100px" }}
                    onClick={() => navigate("/home")}
                    >
                      <HouseDoor style={{ fontSize: "1em" }}/><br/>
                    Home
                    </Col>
                    <Col
                    as={Button} variant="light"
                    className="px-1 py-3 border"
                    style={{
                      flex: 1,
                      height: "70px",
                      width: "100px",
                      textDecoration: "none",
                    }}
                    onClick={() => navigate("/home/my-transactions")}
                    >
                      <CardChecklist style={{ fontSize: "1em" }} /><br/>
                    Transactions
                    </Col>
                    <Col
                    as={Button} variant="light"
                    className="px-1 py-3 border"
                    style={{ flex: 1, height: "70px", width: "100px" }}
                    onClick={()=>setShowContact(!showContact)}
                    >
              {showContact && ( 
            <div className="dropdown-menu show position-absolute text-center text-light p-2 bg-dark" style={{ top: '-150%', right:'25%'}}>
              <p><a href="https://chat.whatsapp.com/Fi15SXmivPlJbQToZ5lT8r" style={{ textDecoration: "none", color: "inherit" }}>Whatsapp Group</a></p>
              <p><a href="https://wa.me/233548785316" style={{ textDecoration: "none", color: "inherit" }}>Whatsapp Admin</a></p>
              {/* <p><a href="mailto:support@ghanabundles.com" style={{ textDecoration: "none", color: "inherit" }}>Email Admin</a></p> */}
            </div>
          )} 
                    <Headset  style={{ fontSize: '1em' }} /><br/>
                    Support
                    </Col>
                    <Col
                    as={Button}
                    variant="light"
                    className="px-1 py-3 border"
                    style={{ flex: 1, height: "70px", width: "100px" }}
                    onClick={() => navigate("/home/user-details")}
                    >
                    <PersonCircle  style={{ fontSize: '1em' }} /><br/>
                    Profile
                    </Col>
                  </Row>
                  {/* <p >Developed by SUPERJCYBS</p> */}
                </Container> 
      <ToastIt
        Variance={variance}
        Message={toastMessage}
        ShowToast={showToast}
        OnClose={() => setShowToast(false)}
      />
            <Modal
              show={showAlert}
              onHide={handleClose}
              backdrop="static"
              keyboard={false}
              size="sm"
              aria-labelledby="contained-modal-title-vcenter"
              centered
            >
              <Modal.Header className="bg-info" closeButton>
                <Modal.Title
                  className="w-100 text-center"
                  id="contained-modal-title-vcenter"
                >
                  PAYMENT NOTICE
                </Modal.Title>
              </Modal.Header>
              <Modal.Body className="text-center bg-light">
                <p>Make payment of <b>&cent; 50</b> to include reference code for faster top-up reflection.</p>
                <span>ACCOUNT NUMBER</span>
                <h3 className="text-danger">{noticeContent.momoPhoneNumber}</h3>
                <hr />
                <span>ACCOUNT NAME</span>
                <p className="text-primary">
                  {" "}
                  <b>{noticeContent.momoAccountName}</b>
                </p>
                {/* <span style={{fontWeight:'bold', backgroundColor:'brown', color:'yellow', padding:'5px', borderRadius: '8px', marginBottom:'5px'}}>NETWORK: {noticeContent?  noticeContent.momoNetwork : 'MTN'}</span> */}
                <p>USE THIS REFERENCE CODE </p>{" "}
                <h3 className="text-danger">{rechargeID}</h3> 
                CLICK ON I HAVE PAID AFTER SUCCESSFULLY SENT THE MONEY<br/>
                <Button variant="danger" onClick={handleRequest}>I have paid</Button>
              </Modal.Body>
              {/* <Modal.Footer className="bg-info text-center">
                <small>For any complaints, send sms to 0595548478</small>
              </Modal.Footer> */}
            </Modal>
    </>
  );
}

export default HomeScreen;
